import * as Yup from 'yup';

import { payoffAmountValidation } from '../../utils/validation/payoffAmount';

export type PayoffValues = {
  totalPayoff?: number;
  vehiclePayoff?: number;
  salesTaxFromPayoff?: number;
  goodThroughDate?: Date;
};

const YESTERDAY = new Date(new Date().setDate(new Date().getDate() - 1));

export const validationSchema = Yup.object({
  totalPayoff: payoffAmountValidation,
  goodThroughDate: Yup.date()
    .min(YESTERDAY, 'Cannot be in the past')
    .nullable()
    .required('Please enter a valid date'),
});

export const isPayoffEstimated = (payoff: number) => {
  return payoff % 100 === 0;
};
